
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import globalConstants from '@/shared/globalConstants';
import ReturnOptions from '@/components/ReturnOptions.vue';

import { MissingEntityType } from '@/types/MissingEntityType';
import Truck from '@/types/Truck';
import Driver from '@/types/Driver';

export default defineComponent({
    name: 'AlertSidebar',
    components: {
        ReturnOptions,
    },
    props: {
        isLoading: Boolean,
    },
    computed: {
        ...mapGetters({
            truck: 'getTruck',
            driver: 'getDriver',
            error: 'getError',
        }),
        isMissingTruckOrDriver(): boolean {
            return this.missingTruckOrDriver !== MissingEntityType.NONE;
        },
        isMissingTruckLocation(): boolean {
            return (
                this.truck instanceof Truck &&
                this.truck.latitude === 0 &&
                this.truck.longitude === 0
            );
        },
        truckOrDriver(): string {
            return this.missingTruckOrDriver === MissingEntityType.DRIVER
                ? 'Driver Code'
                : 'Truck Number';
        },
        missingTruckOrDriver(): MissingEntityType {
            if (
                this.driver === null ||
                this.error?.reasonCode ===
                    globalConstants.reasonCodes.driverNotFound
            ) {
                return MissingEntityType.DRIVER;
            } else if (
                (this.driver instanceof Driver &&
                    this.driver.truckCode.trim() === '') ||
                this.truck === null ||
                this.error?.reasonCode ===
                    globalConstants.reasonCodes.truckNotFound
            ) {
                return MissingEntityType.TRUCK;
            } else {
                return MissingEntityType.NONE;
            }
        },
        message(): string {
            if (this.isMissingTruckOrDriver) {
                return `Unable to Identify ${this.truckOrDriver}`;
            } else {
                return 'We are unable to locate your truck.';
            }
        },
    },
});
